export default {
  common_button_back: '戻る',
  common_button_cancel: 'キャンセル',
  common_button_next: '次へ',
  common_button_no: 'いいえ',
  common_button_ok: 'OK',
  common_button_reset: 'Reset',
  common_button_skip: 'スキップ',
  common_button_yes: 'はい',
  common_deactivated_message:
    'This kiosk has been activated on another device and is thus no longer active on this one. Please log in again. Thank you!',
  common_deactivated_title: 'Kiosk deactivated on this device',
  common_enterEmail_email: '仕事用のメールアドレスを入力してください',
  common_enterEmail_title: 'メールアドレス',
  common_error_message_cameraNotAllowed: 'この機能を使用するにはカメラへのアクセスを許可する必要があります。',
  common_error_message_ForbiddenException: '権限が不足しています',
  common_error_message_incorrectEmail: '正しいメールアドレスを入力してください',
  common_error_message_invalidCredentials: 'ユーザー名またはパスワードが正しくありません。もう一度やり直してください。',
  common_error_message_invalidMobile: 'Please enter a valid mobile phone number',
  common_error_message_missingField: '必須フィールド',
  common_error_message_noInternetConnection: 'インターネット接続が失われました。もう一度やり直してください。',
  common_error_message_unauthorizedAccess: '不正なアクセス',
  common_error_message_webServiceWrongConnection: 'データ転送中にエラーが発生しました。もう一度やり直してください。',
  common_error_title: 'エラー',
  common_expired_message:
    'Either your trial has expired or the credit card we have on file stopped working. Please upgrade in order to re-activate the account. Contact sales@proxyclick.com if you have any questions. Thank you!',
  common_expired_title: 'Account expired',
  common_onboarding_login_button: 'Log in',
  common_onboarding_message1: 'Proxyclick helps you singleTenantWelcome your visitors exactly the way you want to.',
  common_onboarding_message2:
    'Brand your check-in process and your badges, and ask your visitors only the questions that apply to them.',
  common_onboarding_message3: 'Hosts get notified when their guests arrive and can reply instantly.',
  common_onboarding_message4:
    'Protect your facilities and ensure compliance through emergency lists, watch lists, NDAs, privacy rules ...',
  common_onboarding_message5:
    'Proxyclick does the hard work so you can singleTenantWelcome your visitors with a smile.',
  common_placeholder_optional: 'オプション',
  common_setup_activationCode_activate_button: 'Activate',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Eg. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Invalid activation code',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Activate kiosk with unique code',
  common_setup_device_footer: '新しいキオスクを作成するには Proxyclick ウェブアプリケーションに接続してください',
  common_setup_device_locked_content:
    'このキオスクは既に別の iPad で使用です。現在使用中の iPad でこのキオスクを設定すると、他の iPad のキオスクは無効化されます。この iPad のキオスクをセットアップしてもよろしいですか？',
  common_setup_device_locked_continue_button: 'このキオスクを設定',
  common_setup_device_locked_title: 'キオスクは既に使用中です',
  common_setup_device_multiTenants: '複数の企業',
  common_setup_device_title: 'キオスクを選択してください',
  common_setup_loading_footer: 'キオスクをカスタマイズするには Proxyclick ウェブアプリケーションに接続してください',
  common_setup_loading_message: '設定中...',
  common_setup_loading_title: 'キオスクを設定中...',
  common_setup_location_footer: '新しいサイトを作成するには Proxyclick ウェブアプリケーションに接続してください',
  common_setup_location_kiosk: 'キオスク',
  common_setup_location_kiosks: 'キオスク',
  common_setup_location_title: 'サイトを選択してください',
  common_setup_login_activationCode_button: 'Activate with unique code?',
  common_setup_login_email: 'メールアドレス',
  common_setup_login_forgotPassword_button: 'パスワードをお忘れですか？',
  common_setup_login_password: 'パスワード',
  common_setup_login_title: 'Proxyclick アカウントでログインしてください',
  common_setup_ready_header: 'この iPad をあなたの {0} 社のキオスクとして設定する準備はできていますか？',
  common_setup_ready_message: 'ほんの数分設定するだけでキオスクが起動し運用を開始します',
  common_setup_ready_setup_button: 'セットアップ',
  common_setup_ready_title: 'こんにちは {0} 様',
  common_signup_company: '会社名',
  common_signup_email: 'メールアドレス',
  common_signup_error_name: '名前と姓を入力してください',
  common_signup_loading_message1:
    'Proxyclick ウェブアプリケーションに接続してキオスクをカスタマイズできます。あなたに全詳細をメールで送信いたしました。',
  common_signup_loading_message2: 'ウェブサイトからチェックイン時にバッジを印刷するプリンターを設定できます。',
  common_signup_loading_message3: 'また、チェックイン時にホストに送信する通知を有効にすることができます。',
  common_signup_loading_message4: 'さらにあなたのキオスクを独自の色とウェルカム画像でカスタマイズします。',
  common_signup_loading_title: 'アカウントを設定中...',
  common_signup_name: '名前',
  common_signup_name_placeholder: '名前、姓',
  common_signup_password: 'パスワード',
  common_signup_title: 'Proxyclick へようこそ',
  common_signup_tryFree_button: '送信',
  common_timeout_content: 'タッチして中止します',
  common_timeout_title: 'ホーム画面に戻る',
  common_tooltip_disable_button: 'すべてのヒントを無効化',
  common_tooltip_gotIt_button: '了解',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} には、パッケージを配信したことが通知されています',
  dm_delivery_confirmation_title: 'ありがとうございます！',
  dm_delivery_confirmation_unknownRecipient:
    '{{Company_Name}} にパッケージを配達したことを知らせる通知が送信されました',
  dm_delivery_recipient_name: 'このパッケージの対象者',
  dm_delivery_recipient_unknown_button: 'わかりません',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: '登録されました！',
  vm_checkin_confirmation_header_withPrint: 'バッジを印刷中です',
  vm_checkin_confirmation_message: 'おかけください。{{Host_FirstName}} がすぐに参ります。',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: 'ありがとうございます！',
  vm_checkin_details_companyName: '会社名',
  vm_checkin_details_email: 'メールアドレス',
  vm_checkin_details_firstname: '名前',
  vm_checkin_details_lastname: '姓',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn:
    'チェックインを完了中にエラーが発生しました。フロントにお問い合わせください。',
  vm_checkin_flow_company: '会社名',
  vm_checkin_flow_duration: 'Visit duration',
  vm_checkin_flow_email: 'メールアドレス',
  vm_checkin_flow_error_message_imageNotAvailable: '現在画像を利用できません（インターネット接続の問題）',
  vm_checkin_flow_licensePlate: 'ライセンスプレート',
  vm_checkin_flow_mobile: '携帯電話番号を入力してください',
  vm_checkin_flow_mobile_info: 'これは、施設にいる間に緊急事態が発生した場合に連絡を取るために使用されます',
  vm_checkin_flow_tooltip_content:
    '訪問者のエクスペリエンスを改善したりチェックインをより安全にするために必要なものを訪問者に要求してください。訪問者の回答によって質問の流れを変更することができます。表示されている質問は単なるデモ用のサンプルです。',
  vm_checkin_flow_tooltip_title: 'スマートクエスチョン',
  vm_checkin_host_enterFullName: '担当者の氏名を入力してください',
  vm_checkin_host_name: '訪問先の担当者は誰ですか？',
  vm_checkin_host_notListed_block: 'リストの中に担当者が不明または見つからない場合は受付係と話し合ってください',
  vm_checkin_host_notListed_continue: 'この一覧にはいません',
  vm_checkin_host_tooltip_content:
    'こちらにお名前をご記入いただきますと、訪問者が到着した際に従業員に通知メールを送信します。',
  vm_checkin_host_tooltip_title: '訪問者の到着通知',
  vm_checkin_host_unknown_button: 'わかりません',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'Learn more',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: '同意',
  vm_checkin_instructions_clearSignature_button: '消去',
  vm_checkin_instructions_sendCopy_button: 'メールでコピーを送ってください',
  vm_checkin_instructions_sendCopyTo_button: '{0} (変更) にコピーが送信されます',
  vm_checkin_instructions_sign: 'ここに指で署名してください',
  vm_checkin_instructions_tooltip_content:
    '単純なタップまたは署名を使った訪問ルールを来客に受け入れてもらいましょう。訪問者のチェックインの種類に応じて条件を調整することができます。この機能やその他多くの機能を Proxyclick のダッシュボードでカスタマイズすることができます。',
  vm_checkin_instructions_tooltip_title: '署名、捺印されました',
  vm_checkin_method_name: 'こんにちは、お名前を伺ってもよろしいですか？',
  vm_checkin_method_name_enterFullName: 'あなたの氏名を入力してください',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: '一覧の中に見つかりませんか？受付でご確認ください。',
  vm_checkin_method_name_notRegistered_continue: '一覧の中に見つかりませんか？',
  vm_checkin_method_tooltip_content:
    'どのような結果が返ってくるか、または事前に登録済みの訪問者がどのように認識されるかを確認するには「Justin Diaz」でチェックインしてください。 \n\nまたは予期しない訪問者がどのように処理されるかを確認するにはランダムな名前を入力してください。',
  vm_checkin_method_tooltip_title: '訪問者の認識',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: '写真を撮る',
  vm_checkin_picture_title: '写真を撮影しましょう！',
  vm_checkin_picture_tooltip_content:
    'キオスクをお客様のニーズに合わせて調整し、訪問者の写真撮影やバッジの印刷などの機能を追加または削除することができます。',
  vm_checkin_picture_tooltip_title: 'オプション機能',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: "Hello, what's your email address?",
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Save my info to speed up my next check-in',
  vm_checkin_saveInfo_email_placeholder: 'Enter your email address',
  vm_checkin_saveInfo_title: 'Enter your email',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'チェックイン',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: '詳細を編集',
  vm_checkin_summary_groupStats: '既に {1} 人中 {0} 人がそこにいます',
  vm_checkin_summary_meetingTime: '{0} での会議',
  vm_checkin_summary_reviewDetails_button: '訪問の詳細を確認',
  vm_checkin_summary_sendPass_button: '今後の訪問のためスマートフォンにパスを送信',
  vm_checkin_summary_sendPassTo_button: '{0} (変更) に永続的なパスが送信されます',
  vm_checkin_summary_takeNewPicture_button: '新しい写真を撮る',
  vm_checkin_summary_title: '{{Company_Name}} へのあなたの訪問',
  vm_checkin_summary_visiting: '{0} を訪問',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'ようこそ {{Visitor_FirstName}} 様！',
  vm_checkin_welcome_lastVisit_date: 'Your last visit was on {0}',
  vm_checkin_welcome_lastVisit_today: 'Your last visit was earlier today',
  vm_checkin_welcome_lastVisit_yesterday: 'Your last visit was yesterday',
  vm_checkin_welcome_returning: 'おかえりなさいませ {{Visitor_FirstName}} 様！',
  vm_checkout_confirmation_header: 'ごきげんよう、{{Visitor_FirstName}} 様！',
  vm_checkout_confirmation_message: 'チェックアウトしました。ご訪問をお楽しみいただけていたら幸いです。',
  vm_checkout_confirmation_title: 'お越し頂きありがとうございます！',
  vm_checkout_method_name: 'お名前を入力してチェックアウトしてください',
  vm_checkout_method_name_notFound: '見つかりません',
  vm_checkout_method_title: 'チェックアウトしてみましょう',
  vm_identification_id_button: 'あなたの ID をスキャン',
  vm_identification_qrCode_button: '招待状/パスをスキャン',
  vm_infopack_confirmation: 'ありがとうございます！情報を {0} に送りました。',
  vm_infopack_email: 'Proxyclick に関する情報をお届けすることができるよう、あなたのメールアドレスを入力してください。',
  vm_infopack_likeCheckIn: 'Liked this check-in? Tap here to learn more',
  vm_infopack_likeProcess: 'Liked this process? Tap here to learn more',
  vm_infopack_send_button: '情報を送信してください',
  vm_multiTenant_title: 'ようこそ、訪問先の会社はどちらですか？',
  vm_product_footer_learnMore: 'Learn more',
  vm_product_footer_noPartner: "You're using Proxyclick Welcome",
  vm_product_footer_partner: "You're using Proxyclick Welcome, brought to you by {0}",
  vm_qrCode_help: 'コードをカメラから 10-15 cm 離したままにしてください',
  vm_qrCode_not_recognized: 'コードを認識できませんでした',
  vm_qrCode_title: 'バッジまたは Passbook のコードをスキャンします',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>訪問者への指示ならびに機密保持契約</h1><p>ようこそ！当社 {{Company_Name}} の設備であなたを来訪客としてお迎えいたします。</p><h2>健康と安全に関する手引き</h2><p>当社はお客様の訪問中の身の安全に関心を寄せています。つきましては次の事項に従っていただきますようお願いいたします。</p><ul><li><b>敷地内へのアクセス</b> は{{Company_Name}} 社の従業員が同伴している場合にのみ許可されます。</li><li>訪問者<b>バッジ</b> は常時着用し、出発時に受付までご返却いただく必要があります。</li><li><b>緊急</b>時には、すべての訪問者は最寄りの非常口から即座に敷地を立ち去り、指定された集合場所へ移動しなければいけません。</li><li>訪問者の敷地内または周辺設備の<b>撮影を禁じます</b>（写真やビデオ）。</li><li>建屋内での<b>喫煙は固く禁じられています</b>。</li></ul><h2>機密保持契約</h2><p>{{Company_Name}}の施設を訪問中、訪問者は一般に公開されていない企業独自の、または機密の情報（技術、プロセス、機器、図面および仕様に関する情報を無制限に含む）を認知または目にする可能性があります（以下、これらをまとめて&#34;機密情報&#34;と呼ぶ）。</p><p>あなたの{{Company_Name}}社の施設への訪問許可を考慮し、また訪問中のあなたに好意を示し、あなたは以下のいずれの行為も行わないものとします。</p><p>(a) 今回の訪問または以降の訪問であなたに開示された一切の機密情報を第三者に開示、または第三者が利用可能とすること。あるいは</p><p>(b) 機密情報の利用または第三者による利用の支援、またはあらゆる機密情報を任意の方法でさらに明らかにすること。</p><p>(c) カメラやビデオ技術を使用して機密情報を開示すること。</p><p>本設備に署名することにより、健康と安全に関する手引きおよび機密保持契約の内容を理解し同意したものとします。</p>',
  vm_signup_defaultInstruction_name: 'すべての訪問者が署名すべき説明文',
  vm_signup_defaultInstruction_title: '以下を確認し、署名してください。',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'チェックイン',
  vm_welcome_checkout_button: 'チェックアウト',
  vm_welcome_delivery_button: 'Delivery',
  vm_welcome_hello_line1: 'こんにちは、',
  vm_welcome_hello_line2: 'チェックインしてください',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Been here before?',
  vm_welcome_title: '{{Company_Name}} へようこそ',
  vm_welcome_tooltip_content:
    'あなたのキオスクをパーソナライズするには Proxyclick ウェブアプリケーションにログインします。たった今、手順を記載したメールをあなたへ送信しました。ウェブアプリではロゴや背景画像をアップロードして色を選び、あなたのキオスクをブランド ・ アイデンティティに反映することができます。',
  vm_welcome_tooltip_title: '自分で作る',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  common_or: 'または',
};
